import { useEffect, useState } from 'react'
import { productionCommissionsApi } from '@/api/productionCommissions'

export default function ProductionCommissionCover({ id, url, alt, className }: { id: string; url: string; alt: string; className: string }) {
  const [source, setSource] = useState(url.startsWith('data:') || id.startsWith('example-') ? url : '')
  useEffect(() => {
    if (url.startsWith('data:') || id.startsWith('example-')) { setSource(url); return }
    const match = url.match(/\/covers\/(\d+)(?:\?|$)/)
    if (!match) { setSource(''); return }
    let active = true
    let objectURL = ''
    void productionCommissionsApi.cover(id, Number(match[1])).then(value => { objectURL = value; if (active) setSource(value); else URL.revokeObjectURL(value) }).catch(() => { if (active) setSource('') })
    return () => { active = false; if (objectURL) URL.revokeObjectURL(objectURL) }
  }, [id, url])
  return source ? <img src={source} alt={alt} className={className} /> : <div aria-label={alt} className={className + ' bg-slate-100'} />
}
